import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {useSelectedProjectStore} from "@domains/boards/stores/selected-project.store";
import {useWorkspaceStore} from "@shared/stores/workspace.store.ts";
import {useEstimationStore} from "@domains/boards";

export const getEstimationResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
): Promise<void> => {

  const workspaceStore = useWorkspaceStore()
  if (!workspaceStore || !workspaceStore.hasBusinessProduct) {
    if (from?.fullPath) {
      next(from.fullPath);
    } else {
      next(false);
    }
    return;
  }

  const projectStore = useSelectedProjectStore();
  const estimationStore = useEstimationStore()
  const workspaceId = workspaceStore.getSelectedWorkspaceId;
  const projectId = projectStore.getSelectedProjectId;

  estimationStore.loadProjectEstimations(workspaceId, projectId).then(() => next());
};
